export default (value, length, clamp) => {
  const clampValue = clamp || '...';
  const node = document.createElement('div');
  node.innerHTML = value || '';
  const content = node.textContent;
  return content.length > length ? content.slice(0, length) + clampValue : content;
};



// WEBPACK FOOTER //
// ./src/filters/truncate.js